import React, { useState } from 'react';
import { FileText, ZoomIn, ZoomOut, RotateCw } from 'lucide-react';

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.tiff', '.tif', '.heic', '.heif', '.webp', '.bmp'];

function isImageFile(filename) {
  if (!filename) return false;
  const ext = filename.substring(filename.lastIndexOf('.')).toLowerCase();
  return IMAGE_EXTENSIONS.includes(ext);
}

export default function PDFViewer({ url, filename }) {
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  if (!url) {
    return (
      <div className="flex flex-col items-center justify-center h-full bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 p-8">
        <FileText className="w-16 h-16 text-gray-300 mb-3" />
        <p className="text-gray-400 text-sm">No hay documento disponible</p>
      </div>
    );
  }

  if (isImageFile(filename)) {
    return (
      <div className="w-full rounded-lg overflow-hidden border border-gray-200">
        <div className="flex items-center gap-1 p-2 bg-gray-50 border-b border-gray-200">
          <button
            onClick={() => setZoom((z) => Math.min(z + 0.25, 3))}
            className="p-1.5 hover:bg-gray-200 rounded text-gray-600"
            title="Ampliar"
          >
            <ZoomIn className="w-4 h-4" />
          </button>
          <button
            onClick={() => setZoom((z) => Math.max(z - 0.25, 0.25))}
            className="p-1.5 hover:bg-gray-200 rounded text-gray-600"
            title="Reducir"
          >
            <ZoomOut className="w-4 h-4" />
          </button>
          <button
            onClick={() => setRotation((r) => (r + 90) % 360)}
            className="p-1.5 hover:bg-gray-200 rounded text-gray-600"
            title="Rotar"
          >
            <RotateCw className="w-4 h-4" />
          </button>
          <span className="text-xs text-gray-400 ml-2">{Math.round(zoom * 100)}%</span>
        </div>
        <div className="overflow-auto bg-gray-100" style={{ maxHeight: '70vh' }}>
          <img
            src={url}
            alt="Documento factura"
            className="mx-auto transition-transform duration-200"
            style={{
              transform: `scale(${zoom}) rotate(${rotation}deg)`,
              transformOrigin: 'center center',
              maxWidth: zoom <= 1 ? '100%' : 'none',
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full min-h-[600px] rounded-lg overflow-hidden border border-gray-200">
      <iframe
        src={url}
        title="Visor PDF"
        className="w-full h-full min-h-[600px]"
        style={{ border: 'none' }}
      />
    </div>
  );
}
